import state from "./state";
import mutations from "./mutations";
import * as actions from "./actions";
import * as getters from "./getters";
import filters from "./filters";

export default {
  state,
  actions,
  getters,
  mutations,
  modules: { filters },
  namespaced: true,
};
